import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
    standalone: false
})
export class InfoTooltipComponent {
  @Input() text: string;
}
